
export const AJAX_PATH = '/web-services';
export const DISABLED_VALUE = (window.MSP_disabledValue) ? window.MSP_disabledValue : '#DISABLED#';
export const SELF_DISABLED_VALUE = (window.MSP_selfDisabledValue) ? window.MSP_selfDisabledValue : '#SELF_DISABLED#';
export const DISABLED_COLUMNS = '$$disabledColums';

export const SURVEY_CSS_ADDENDUM = {
    root: 'survey__root',
    pageTitle: 'survey__page-title',
    row: 'survey__row',
    question: {
        root: 'survey__question',
        title: 'survey__question__title',
        indent: 60,
    },
    text: 'form-control survey__text',
    error: {
        icon: 'glyphicon glyphicon-exclamation-sign',
        item: 'item-error-msg',
        root: 'well well-sm dynamic-error-msg',
    },
    navigation: {
        complete: 'btn btn-primary btn-wide btn--submit',
        next: 'btn btn-primary btn-wide btn--next',
        prev: 'btn btn-primary btn-wide btn--prev',
    },
    matrix: { root: 'table survey__matrix' },
    matrixdropdown: { root: 'table survey__matrix survey__matrix--dropdown' },
    matrixdynamic: { root: 'table survey__matrix survey__matrix--dynamic' },
    multipletext: { root: 'table survey__multipletext', itemTitle: 'survey__item-title' },
};

export const TRIGGER_TYPE_ANSWER_TIP = 'answer_tip';
export const TRIGGER_TYPE_QUESTION_TIP = 'question_tip';

export const ANALYST_GOTO_URL = '/bilans/recherche/aller-a';
export const ANALYST_MAP_URL = '/bilans/cartographie';

export const MONTHS = [
    'Janvier',
    'Février',
    'Mars',
    'Avril',
    'Mai',
    'Juin',
    'Juillet',
    'Août',
    'Septembre',
    'Octobre',
    'Novembre',
    'Décembre',
];



// WEBPACK FOOTER //
// ./resources/assets/js/constants.js